export var ACTION;
(function (ACTION) {
    ACTION["ONLOAD"] = "ONLOAD";
    ACTION["INIT"] = "INIT";
    ACTION["VERIFY"] = "VERIFY";
    ACTION["CLOSE_MODAL"] = "CLOSE_MODAL";
    ACTION["TEXT_CHANGE"] = "TEXT_CHANGE";
    ACTION["NAV_TO_STEPPER"] = "NAV_TO_STEPPER";
})(ACTION || (ACTION = {}));
